module.exports = __webpack_public_path__ + "img/ji.138fedc7.png";